import { type VariantProps, cva } from "class-variance-authority";
import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "../lib/cn";

export const iconButtonVariants = cva(
	"inline-flex items-center justify-center rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
	{
		variants: {
			variant: {
				default: "bg-primary text-primaryForeground hover:bg-primary/90",
				outline:
					"border border-input bg-background hover:bg-accent hover:text-accentForeground",
				ghost: "hover:bg-accent hover:text-accentForeground",
				destructive:
					"bg-destructive text-destructiveForeground hover:bg-destructive/90",
			},
			size: {
				sm: "h-8 w-8",
				default: "h-10 w-10",
				lg: "h-12 w-12",
			},
		},
		defaultVariants: {
			variant: "ghost",
			size: "default",
		},
	},
);

export interface IconButtonProps
	extends ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof iconButtonVariants> {
	"aria-label": string;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
	({ className, variant, size, ...props }, ref) => (
		<button
			ref={ref}
			className={cn(iconButtonVariants({ variant, size, className }))}
			type="button"
			{...props}
		/>
	),
);
IconButton.displayName = "IconButton";

export default IconButton;
export { IconButton };
